import React from 'react';
import { useLanguage } from '../LanguageContext';
import './LandingPage.css';

interface LandingPageProps {
  onGetStarted: () => void;
  onArtistLogin: () => void;
}

const LandingPage: React.FC<LandingPageProps> = ({ onGetStarted, onArtistLogin }) => {
  const { t, language, setLanguage } = useLanguage();

  return (
    <div className="landing">
      <div className="landing-bg">
        <div className="landing-orb landing-orb-1"></div>
        <div className="landing-orb landing-orb-2"></div>
        <div className="landing-orb landing-orb-3"></div>
      </div>
      
      <header className="landing-header">
        <div className="landing-logo">
          <div className="logo-icon">🎵</div>
          <span className="logo-text">{t.landing.title}</span>
        </div>
        <div className="header-right">
          <div className="lang-switcher">
            <button 
              className={`lang-btn-sm ${language === 'de' ? 'active' : ''}`}
              onClick={() => setLanguage('de')}
            >
              DE
            </button>
            <button 
              className={`lang-btn-sm ${language === 'en' ? 'active' : ''}`}
              onClick={() => setLanguage('en')}
            >
              EN
            </button>
          </div>
          <button className="btn btn-outline" onClick={onArtistLogin}>
            {t.landing.artistLogin}
          </button>
        </div>
      </header>

      <main className="landing-hero">
        <div className="hero-content">
          <h1 className="hero-title">
            {language === 'de' ? (
              <>
                Spüre den <span className="text-gradient">Rhythmus</span>,<br />
                Werde der <span className="text-gradient">Champion</span>
              </>
            ) : (
              <>
                Feel the <span className="text-gradient">Rhythm</span>,<br />
                Beat the <span className="text-gradient">Score</span>
              </>
            )}
          </h1>
          <p className="hero-subtitle">
            {t.landing.subtitle}
          </p>
          <div className="hero-cta">
            <button className="btn btn-primary btn-large" onClick={onGetStarted}>
              {t.landing.getStarted}
            </button>
            <p className="hero-note">
              {language === 'de' 
                ? 'Kein Download nötig. Spiele direkt im Browser.'
                : 'No download required. Play instantly in your browser.'
              }
            </p>
          </div>
        </div>

        <div className="hero-visual">
          <div className="phone-mockup">
            <div className="phone-screen">
              <div className="mockup-beat"></div>
              <div className="mockup-beat mockup-beat-2"></div>
              <div className="mockup-beat mockup-beat-3"></div>
              <div className="mockup-lane"></div>
            </div>
          </div>
        </div>
      </main>

      <section className="landing-features">
        <div className="feature">
          <div className="feature-icon">🏆</div>
          <h3>{t.landing.features.compete}</h3>
          <p>{t.landing.features.compete_desc}</p>
        </div>
        <div className="feature">
          <div className="feature-icon">🎧</div>
          <h3>{t.landing.features.music}</h3>
          <p>{t.landing.features.music_desc}</p>
        </div>
        <div className="feature">
          <div className="feature-icon">👥</div>
          <h3>{t.landing.features.social}</h3>
          <p>{t.landing.features.social_desc}</p>
        </div>
      </section>

      <section className="landing-artists">
        <h2>{language === 'de' ? 'Bist du Künstler?' : 'Are You an Artist?'}</h2>
        <p>
          {language === 'de' 
            ? 'Lass tausende Spieler zu deiner Musik spielen. Lade deine Tracks hoch und werde entdeckt.'
            : 'Get your music heard by thousands of players. Upload your tracks and let players compete on your beats.'
          }
        </p>
        <button className="btn btn-secondary" onClick={onArtistLogin}>
          {t.landing.artistLogin}
        </button>
      </section>

      <footer className="landing-footer">
        <p>© 2026 WarsoWerk. Made with 🎵</p>
      </footer>
    </div>
  );
};

export default LandingPage;
